function sortByName(data) {
  return data.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    return 0;
  });
}

function sortByPlayspace(data) {
  return data.sort((a, b) => {
    if (a.playspace > b.playspace) {
      return 1;
    }
    if (a.playspace < b.playspace) {
      return -1;
    }
    return 0;
  });
}

function sortByClassSpace(data) {
  return data.sort((a, b) => {
    if (a.classroomspace > b.classroomspace) {
      return 1;
    }
    if (a.classroomspace < b.classroomspace) {
      return -1;
    }
    return 0;
  });
}

export const studentEnrolment = function(schools) {
  return sortByName(
    schools.filter(d => {
      if (!d.enrolment || d.enrolment === 'NA') {
        console.warn(`${d.name} is missing current enrolment details`);
        return false;
      }
      return true;
    })
  );
};

export const studentClassrooms = function(schools) {
  return sortByName(
    schools.filter(d => {
      if (
        !d.classrooms ||
        d.classrooms.permanent === 'NA' ||
        d.classrooms.demountable === 'NA'
      ) {
        console.warn(`${d.name} is missing classroom numbers`);
        return false;
      }
      return true;
    })
  );
};

export const playspace = function(schools) {
  return sortByPlayspace(
    schools
      .filter(d => {
        // Dealing with real world edge cases
        if (d.playspace === 'NA' || d.playspace < 1 || isNaN(d.playspace)) {
          if (d.playspace < 1) {
            console.warn(
              `${d.name} playspace is less than 1m² and cannot be show in visualisation`
            );
          } else {
            console.warn(`${d.name} is missing playspace information`);
          }
          return false;
        }
        return true;
      })
      .map(d => d)
  );
};

export const classSpace = function(schools) {
  return sortByClassSpace(
    schools
      .filter(d => {
        // Dealing with real world edge cases
        if (
          d.classroomspace === 'NA' ||
          d.classroomspace < 1 ||
          isNaN(d.classroomspace)
        ) {
          if (d.classroomspace < 1) {
            console.warn(
              `${d.name} classroom space is less than 1m² and cannot be show in visualisation`
            );
          } else {
            console.warn(`${d.name} is missing classroom space information`);
          }
          return false;
        }
        return true;
      })
      .map(d => d)
  );
};

export default {
  studentEnrolment,
  studentClassrooms,
  playspace,
  classSpace,
};



// WEBPACK FOOTER //
// ./src/modules/filter-data.js